"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerInput = void 0;
var React = require("react");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var deprecationLog_1 = require("../../common/deprecationLog");
var legacyParse_1 = require("wix-style-react/dist/src/common/LocaleUtils/legacyParse");
var DatePicker_1 = require("wix-style-react/dist/src/DatePicker");
var TextField_1 = require("../TextField/TextField");
var TextFieldEnums_1 = require("../TextField/TextFieldEnums");
var Calendar_1 = require("wix-ui-icons-common/on-stage/Calendar");
var DatePickerInput_st_css_1 = require("./DatePickerInput.st.css");
var constants_1 = require("./constants");
/** The Date pickers presents a calendar and allows a user to select a specific date. */
var DatePickerInput = /** @class */ (function (_super) {
    __extends(DatePickerInput, _super);
    function DatePickerInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.WSRDatePickerRef = React.createRef();
        /** Return a value in which all string-dates are parsed into Date objects */
        _this._parseValue = function (value) {
            if (!value) {
                return;
            }
            if (typeof value === 'string') {
                return legacyParse_1.default(value);
            }
            return value;
        };
        /** This function is used for backward compatibility.
         * In case that the user passes an `date-fns locale object` we take the code value from the object and use Intl.
         * */
        _this._parseLocale = function (locale) {
            var updatedLocale = locale;
            if (typeof locale === 'object') {
                updatedLocale = locale.code ? locale.code : 'en';
            }
            return updatedLocale;
        };
        _this._onInputClearButtonClicked = function () {
            var onChange = _this.props.onChange;
            onChange('');
            _this.WSRDatePickerRef.current.closeCalendar();
        };
        return _this;
    }
    DatePickerInput.prototype.componentDidMount = function () {
        if (typeof this.props.locale !== 'string') {
            deprecationLog_1.deprecationLog('DatePickerInput', 'The prop "locale" with value `date-fns locale object` is deprecated and will be removed in next major release, please pass a string instead.');
        }
    };
    DatePickerInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, value = _a.value, onChange = _a.onChange, onClose = _a.onClose, placeholderText = _a.placeholderText, disabled = _a.disabled, locale = _a.locale, excludePastDates = _a.excludePastDates, filterDate = _a.filterDate, firstDayOfWeek = _a.firstDayOfWeek, hasError = _a.hasError, errorMessage = _a.errorMessage, showMonthDropdown = _a.showMonthDropdown, showYearDropdown = _a.showYearDropdown, inputWidth = _a.inputWidth, inputTheme = _a.inputTheme, popoverPlacement = _a.popoverPlacement, popoverAppendTo = _a.popoverAppendTo, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], dateInputAriaLabel = _a.dateInputAriaLabel, dateInputAriaLabelledby = _a.dateInputAriaLabelledby, clearButtonAriaLabel = _a.clearButtonAriaLabel, clearButtonAriaLabelledby = _a.clearButtonAriaLabelledby, leftArrowAriaLabel = _a.leftArrowAriaLabel, leftArrowAriaLabelledBy = _a.leftArrowAriaLabelledBy, rightArrowAriaLabel = _a.rightArrowAriaLabel, rightArrowAriaLabelledBy = _a.rightArrowAriaLabelledBy, monthDropdownAriaLabel = _a.monthDropdownAriaLabel, monthDropdownAriaLabelledBy = _a.monthDropdownAriaLabelledBy, yearDropdownAriaLabel = _a.yearDropdownAriaLabel, yearDropdownAriaLabelledBy = _a.yearDropdownAriaLabelledBy;
        var CustomInput = function (wsrProps) {
            var formattedValue = wsrProps.value, onFocus = wsrProps.onFocus, onKeyDown = wsrProps.onKeyDown, tabIndex = wsrProps.tabIndex;
            return (React.createElement(TextField_1.TextField, { className: DatePickerInput_st_css_1.classes.textField, "data-hook": constants_1.DATA_HOOKS.DATE_INPUT, value: formattedValue, placeholder: placeholderText, suffix: React.createElement(Calendar_1.default, null), tabIndex: tabIndex, disabled: disabled, error: hasError, errorMessage: errorMessage, theme: inputTheme, withClearButton: true, onFocus: onFocus, onKeyDown: onKeyDown, onClear: _this._onInputClearButtonClicked, clearButtonAriaLabel: clearButtonAriaLabel, clearButtonAriaLabelledby: clearButtonAriaLabelledby, "aria-label": dateInputAriaLabel, "aria-labelledby": dateInputAriaLabelledby }));
        };
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement("div", { className: DatePickerInput_st_css_1.st(DatePickerInput_st_css_1.classes.root, DatePickerInput_st_css_1.classes.overrideStyleParams, className), "data-hook": _this.props['data-hook'], "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy },
                React.createElement(DatePicker_1.default, { ref: _this.WSRDatePickerRef, dataHook: constants_1.DATA_HOOKS.WSR_DATE_PICKER, className: DatePickerInput_st_css_1.classes.wsrDatePicker, value: _this._parseValue(value), onChange: onChange, onClose: onClose, disabled: disabled, locale: _this._parseLocale(locale), excludePastDates: excludePastDates, filterDate: filterDate, firstDayOfWeek: firstDayOfWeek, showMonthDropdown: showMonthDropdown, showYearDropdown: showYearDropdown, customInput: React.createElement(CustomInput, null), width: inputWidth, rtl: rtl, selectionMode: "day", shouldCloseOnSelect: true, initialOpen: false, numOfMonths: 1, popoverProps: {
                        placement: popoverPlacement
                            ? popoverPlacement
                            : rtl
                                ? 'bottom-end'
                                : 'bottom-start',
                        appendTo: popoverAppendTo,
                        dynamicWidth: popoverAppendTo === 'window' ? true : undefined,
                    }, leftArrowAriaLabel: leftArrowAriaLabel, leftArrowAriaLabelledBy: leftArrowAriaLabelledBy, rightArrowAriaLabel: rightArrowAriaLabel, rightArrowAriaLabelledBy: rightArrowAriaLabelledBy, monthDropdownAriaLabel: monthDropdownAriaLabel, monthDropdownAriaLabelledBy: monthDropdownAriaLabelledBy, yearDropdownAriaLabel: yearDropdownAriaLabel, yearDropdownAriaLabelledBy: yearDropdownAriaLabelledBy })));
        }));
    };
    DatePickerInput.displayName = 'DatePickerInput';
    DatePickerInput.defaultProps = {
        placeholderText: 'MM/DD/YY',
        disabled: false,
        locale: 'en',
        excludePastDates: false,
        filterDate: function () { return true; },
        showMonthDropdown: false,
        showYearDropdown: false,
        hasError: false,
        inputWidth: '280px',
        inputTheme: TextFieldEnums_1.TextFieldTheme.Box,
    };
    return DatePickerInput;
}(React.Component));
exports.DatePickerInput = DatePickerInput;
//# sourceMappingURL=DatePickerInput.js.map